import React, { createContext, useContext } from 'react';
import { useQuery, useMutation } from '@apollo/client';

// import { queries, mutations } from './shared/services';
// import { Loader } from './shared/components';
import { Loader } from '../../shared/components';
import { queries, mutations } from '../../shared/services';
/**
 * Context
 */
interface IAuthContext {
  data: {
    user: {} | null;
  };
  login: (options?: any) => any;
  loginIsLoading: boolean;
  logout: () => void;
}

const AuthContext = createContext<IAuthContext>({
  data: { user: null },
  login: () => {},
  loginIsLoading: false,
  logout: () => {},
});

/**
 * Provider
 */
const AuthProvider = (props: any) => {
  const [login, { loading: loginIsLoading }] = useMutation(mutations.LOGIN_USER.mutationBody, {
    refetchQueries: [{ query: queries.CURRENT_USER.queryBody }],
  });
  const [logout] = useMutation(mutations.LOGOUT_USER.mutationBody, {
    refetchQueries: [{ query: queries.CURRENT_USER.queryBody }],
  });
  const { data, loading: isActiveUserLoading } = useQuery(queries.CURRENT_USER.queryBody, {
    pollInterval: 1000 * 60 * 5,
  });
  const userData = data?.currentUser || null;

  if (isActiveUserLoading) {
    return <Loader />;
  }

  return (
    <AuthContext.Provider
      value={{ data: { user: userData }, login, loginIsLoading, logout }}
      {...props}
    />
  );
};

/**
 * Hook
 */
const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
};

export { AuthProvider, useAuth };
